import { j as o } from "../../../../jsx-runtime.BREq8dyb.js";
import { faPlus as c } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as a } from "@fortawesome/react-fontawesome";
import { Dropdown as l, MenuButton as p, Menu as x, MenuItem as u, Box as r, Typography as t } from "@mui/joy";
import { memo as h } from "react";
import { mapCombinatorOperatorToOption as f } from "../../config.js";
const j = h(({
  combinatorOperators: i,
  handleAddAudience: s,
  disabled: m = !1
}) => /* @__PURE__ */ o.jsxs(l, { children: [
  /* @__PURE__ */ o.jsx(p, { color: "primary", disabled: m, startDecorator: /* @__PURE__ */ o.jsx(a, { fixedWidth: !0, icon: c }), sx: {
    mt: 1,
    width: "100%"
  }, variant: "soft", children: "Combine with another audience" }),
  /* @__PURE__ */ o.jsx(x, { children: i.map((e) => {
    const n = f[e], d = n.icon;
    return /* @__PURE__ */ o.jsxs(u, { onClick: () => s(e), children: [
      /* @__PURE__ */ o.jsx(d, {}),
      /* @__PURE__ */ o.jsx(r, { sx: {
        display: "flex",
        gap: 1
      }, children: /* @__PURE__ */ o.jsxs(r, { children: [
        /* @__PURE__ */ o.jsx(t, { children: n.label }),
        /* @__PURE__ */ o.jsx(t, { level: "body-sm", children: n.description })
      ] }) })
    ] }, e);
  }) })
] }));
j.displayName = "AddAudienceButton";
export {
  j as default
};
//# sourceMappingURL=AddAudienceButton.js.map
